import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockLedgerService = {
    getStockLedgerList,
    getStockLedgerDetailList,
    getAllStockLedgerReferenceType,
    exportAllStockLedgerExcel,
    //exportAllStockLedgerDetailExcel,
};

function getStockLedgerList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }

    return axios.get("/auth/stock-ledgers", { params });
}

function getStockLedgerDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }

    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }

    if (searchParams.referenceType) {
        params["referenceType"] = searchParams.referenceType;
    }

    if (searchParams.qcNo) {
        params["qcNo"] = searchParams.qcNo;
    }

    if (searchParams.batchNo) {
        params["batchNo"] = searchParams.batchNo;
    }

    if (searchParams.expDate) {
        params["expDate"] = searchParams.expDate;
    }

    if (searchParams.mfgDate) {
        params["mfgDate"] = searchParams.mfgDate;
    }

    return axios.get("/auth/stock-ledger-details", { params });
}

function getAllStockLedgerReferenceType() {
    return axios.get("/auth/all-reference-types");
}

function exportAllStockLedgerExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-ledger-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

/*function exportAllStockLedgerDetailExcel(searchParams) {
    let params = {};

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }

    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }

    if (searchParams.referenceType) {
        params["referenceType"] = searchParams.referenceType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-ledger-detail-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}*/